module.exports = __webpack_public_path__ + "static/img/t22.c6a7b74c.png";